<template>
  <div class="home-skeleton">
    <!-- Banner骨架屏 -->
    <div class="skeleton-banner">
      <div class="skeleton-item skeleton-banner-item"></div>
    </div>
    
    <!-- 公告骨架屏 -->
    <div class="skeleton-announcement">
      <div class="skeleton-item skeleton-announcement-item"></div>
    </div>
    
    <!-- 热门公告骨架屏 -->
    <div class="skeleton-section">
      <div class="skeleton-title"></div>
      <div class="skeleton-hot-scroll">
        <div class="skeleton-hot-item" v-for="i in 4" :key="i"></div>
      </div>
    </div>
    
    <!-- 热门游戏骨架屏 -->
    <div class="skeleton-section">
      <div class="skeleton-title"></div>
      <div class="skeleton-game-list">
        <div class="skeleton-game-item" v-for="i in 8" :key="i"></div>
      </div>
    </div>
    
    <!-- 热门列表骨架屏 -->
    <div class="skeleton-section">
      <div class="skeleton-title"></div>
      <div class="skeleton-list">
        <div class="skeleton-list-item" v-for="i in 3" :key="i">
          <div class="skeleton-list-left"></div>
          <div class="skeleton-list-right">
            <div class="skeleton-badge"></div>
            <div class="skeleton-tags"></div>
            <div class="skeleton-info"></div>
            <div class="skeleton-button"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeSkeleton'
}
</script>

<style lang="less" scoped>
.home-skeleton {
  padding: 46px 0 0;
}

.skeleton-item {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-banner {
  padding: 5px 15px 0;
  
  .skeleton-banner-item {
    height: 10rem;
    border-radius: 8px;
  }
}

.skeleton-announcement {
  margin: 12px 15px;
  
  .skeleton-announcement-item {
    height: 48px;
    border-radius: 12px;
  }
}

.skeleton-section {
  margin: 20px 0;
  
  .skeleton-title {
    height: 24px;
    width: 120px;
    margin: 0 15px 12px;
    .skeleton-item;
  }
}

.skeleton-hot-scroll {
  display: flex;
  overflow-x: auto;
  padding: 0 8px;
  
  .skeleton-hot-item {
    flex: 0 0 220px;
    height: 260px;
    margin: 0 8px;
    border-radius: 12px;
    .skeleton-item;
  }
}

.skeleton-game-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 0 15px;
  
  .skeleton-game-item {
    aspect-ratio: 1/1;
    border-radius: 12px;
    .skeleton-item;
  }
}

.skeleton-list {
  padding: 0 15px;
  
  .skeleton-list-item {
    display: flex;
    margin-bottom: 16px;
    padding: 16px;
    border-radius: 16px;
    background: #f8f9fa;
  }
  
  .skeleton-list-left {
    width: 100px;
    height: 120px;
    border-radius: 8px;
    .skeleton-item;
  }
  
  .skeleton-list-right {
    flex: 1;
    margin-left: 16px;
    
    .skeleton-badge {
      height: 24px;
      width: 80%;
      margin-bottom: 12px;
      .skeleton-item;
    }
    
    .skeleton-tags {
      height: 20px;
      width: 60%;
      margin-bottom: 12px;
      .skeleton-item;
    }
    
    .skeleton-info {
      height: 40px;
      margin-bottom: 12px;
      .skeleton-item;
    }
    
    .skeleton-button {
      height: 40px;
      border-radius: 20px;
      .skeleton-item;
    }
  }
}

@media (max-width: 375px) {
  .skeleton-hot-scroll .skeleton-hot-item {
    flex: 0 0 120px;
    height: 160px;
  }
  
  .skeleton-game-list {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 320px) {
  .skeleton-game-list {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>